import React, { Component } from "react";

// SCSS
import "./ShoveberryLevelLayoutActionsPanel.scss";

// Icons & Images
import Undo from "static/assets/shoveberry/images/undo-icon.png";
import Restart from "static/assets/shoveberry/images/reset-icon.png";
import Sound from "static/assets/shoveberry/images/sound-icon.png";

// Music
import PlayMusic from "static/assets/shoveberry/sounds/game-play.mp3";

class ShoveberryLevelLayoutActionsPanel extends Component {
  state = {
    play: false,
  };

  // audio = new Audio(PlayMusic);

  // componentDidMount() {
  //   this.audio.addEventListener(
  //     "ended",
  //     () => this.setState({ play: true }),
  //     this.audio.play(),
  //     (this.audio.volume = 0.4)
  //   );
  // }

  // componentWillUnmount() {
  //   this.audio.removeEventListener("ended", () => {
  //     this.setState({ play: false });
  //     this.audio.pause();
  //   });
  // }

  // togglePlay = () => {
  //   this.setState({ play: !this.state.play });
  //   this.audio.volume = 0.4;
  //   this.state.play ? this.audio.play() : this.audio.pause();
  // };

  render() {
    const { handleReset, handleSound, handleUndo } = this.props;
    return (
      <div className="shoveberry-level-layout-actions-panel-component">
        {/* <img
          src={Sound}
          alt=""
          className="shoveberry-level-layout-actions-panel-component__action-btn"
          onClick={() => {
            this.togglePlay();
            // handleSound();
          }}
        /> */}
        <img
          src={Undo}
          alt=""
          className="shoveberry-level-layout-actions-panel-component__action-btn"
          onClick={handleUndo}
        />
        <img
          src={Restart}
          alt=""
          className="shoveberry-level-layout-actions-panel-component__action-btn"
          onClick={handleReset}
        />
      </div>
    );
  }
}
export default ShoveberryLevelLayoutActionsPanel;
